require("dotenv").config()
// console.log(process.env.NODE_ENV);
import axios from "axios"
axios.defaults.baseURL = (process.env.NODE_ENV === "development") ?
    "http://localhost:3407/v2" : "https://edwork.onrender.com/v2";
// axios.defaults.withCredentials = true;
// axios.defaults.baseURL = "http://localhost:3401/v2"
axios.defaults.timeout = 12500;